import css from "./Select.module.css";

type PropsType = {
  onChange: (evt: React.ChangeEvent<HTMLSelectElement>) => void;
  values: Array<{ value: string; name: string }>;
  value?: string;
  label?: string;
};

export const Select = ({ onChange, values, value, label }: PropsType) => {
  return (
    <div className={css.container}>
      {label && <span>{label}:</span>}
      <select className={css.select} onChange={onChange} value={value}>
        {values.map(({ value, name }) => (
          <option value={value} key={value}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};
